module.exports = __webpack_public_path__ + "static/media/0007.1857fb0c.jpg";